import { action, observable, makeObservable } from 'mobx';

class ModalsStore {
  constructor() {
    makeObservable(this);
  }
  // ACTIONS
  @action toggleModal(modalName, isVisible = !this.modalVisibilities[modalName]) {
    this.modalVisibilities[modalName] = isVisible;
  }

  @action hideModal(modalName) {
    this.modalVisibilities[modalName] = false;
  }

  @action showModal(modalName) {
    this.modalVisibilities[modalName] = true;
  }

  // OBSERVABLES
  @observable modalVisibilities = {
    deleteDraft: false,
    removeApp: false,
    withdrawApp: false,
    unsavedChanges: false
  }
}

export const modalsStore = new ModalsStore();
